"use strict";

import { Box } from '@autoguru/overdrive';
import * as styles from './Aside.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const Aside = () => /*#__PURE__*/_jsx(Box, {
  className: styles.root
});